import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import _ from 'lodash';
import proj from 'ol/proj';
import styled from 'styled-components';
import { translate } from "react-i18next";
import ReactSVG from 'react-svg'
import { modalInstance } from './../../Content';
import TiledImageMap from './tiledImageMap/TiledImageMap';
import ImageAdjustmentMenu from './imageAdjustmentMenu/ImageAdjustmentMenu';
import DefaultButton from './../../../../components/DefaultButton';
import DropdownMenu from '../../../../components/DropdownMenu';
import { turnOnPhotosUpdateNotification, turnOffPhotosUpdateNotification } from '../../../../utilities/webSocketNotifications';
import IconPrevious from './../../../../icons/prev.svg';
import IconNext from './../../../../icons/next.svg';
import IconMenu from './../../../../icons/menu.svg';
import PhotoIcon from './../../../../icons/photo.svg';
//import FaultIcon from './../../../../icons/danger.svg';
import {
    getPhotos,
    deletePhoto,
    selectPhoto,
    getPhotoFaults,
    removePhotoSelection
} from '../../../../actions/photos';
import {
    centerMap,
} from './../../../../actions/map';
import {
    startDrawingFaultPhoto,
} from './../../../../actions/faults';
import { MAP_MODE } from './../../../../types/map';

const TilesGalleryWrapper = styled.div`
    position: relative;
    height: calc(100% - 3px);
    width: 100%;
     .TiledImageMap Canvas{
        filter: ${props => `brightness(${props.brightness || 1}) contrast(${props.contrast || 1});`};
    }
`;

const StyledIconWrapper = styled.div`
    display: ${props => props.shown ? 'flex' : 'none'};
    flex-direction: column;
    position: relative;
    width: 100%;
    top: 0px;
    height: 100%;
    align-items: center;
    justify-content: center;
    background-color: #242424;
    color: #ffffff;
`;

const StyledIcon = styled.img`
  height: 30px;
  color: white;
  font-family: Open Sans, sans-serif;
  text-align: center;
  letter-spacing: .5px;
  vertical-align: middle;
  user-select: none;
  display: inline-block;
  text-transform: uppercase;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

const DropDownListRow = styled.div`
    pointer-events: ${props => props.disabled ? 'none' : 'all'};
    background-color: ${props => props.disabled ? 'rgba(256, 256, 256, 0.5)' : 'transparent'};
`;

let chosenFlightTmp = undefined;

class TilesGallery extends React.Component {

    constructor() {
        super();
        this.state = {
            chosenPhotoIndex: 0,
            url: '',
            menuVisible: false,
            synchronized: false,
            displayOrder: true,
            imageAdjustmentMenuVisible: false,
            brightness: 1,
            contrast: 1,
        }
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    closeAdjustmentMenu = () => {
        this.setState({ imageAdjustmentMenuVisible: false })
    }

    setBrightness = (value) => {
        this.setState({ brightness: value })
    }

    setContrast = (value) => {
        this.setState({ contrast: value })
    }

    changeChosenPhotoIndex = (delta) => {
        delta = this.state.displayOrder ? delta : -delta;

        const { photos, centerMap } = this.props
        let index = this.state.chosenPhotoIndex + delta;
        index = index < 0
            ? photos.length - 1
            : index;
        index = index > photos.length - 1
            ? 0
            : index;

        this.setState({
            chosenPhotoIndex: index,
        });
        this.props.selectPhoto(
            photos[index].id,
            photos[index].direction
        );

        const { longitude, latitude } = photos[index];
        const center = proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857");
        centerMap(center);
    }

    deletePhoto = () => {
        const { photos, axiosInstance, deletePhoto, t } = this.props;
        const { chosenPhotoIndex } = this.state;
        const chosenPhoto = photos[chosenPhotoIndex];
        const confirmCallback = () => {
            deletePhoto(axiosInstance, chosenPhoto.id);
        }
        const config = {
            title: t('Do you really want to delete photo') + '?',
            content: <p>{t('Do you really want to delete photo')} <b>{String(chosenPhoto.fileName)}</b>?</p>,
            confirmCallback: confirmCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    componentDidMount() {
        const { chosenFlight, axiosInstance, getPhotos, editMode, selectedPhotoId, selectPhoto, photos } = this.props;

        //Przy uruchamianiu zawsze zaczynamy od misji
        if (chosenFlight && chosenFlight.id) {
            const selectedPhotoIndex = this.getSelectedIdx(photos, selectedPhotoId);
            const photo = photos[selectedPhotoIndex];
            this.setState({ chosenPhotoIndex: selectedPhotoIndex });
            if (photo) selectPhoto(photo.id);
        }

        turnOnPhotosUpdateNotification((message) => {
            if (chosenFlightTmp && chosenFlightTmp.id) {
                getPhotos(axiosInstance, chosenFlightTmp.id);
            }
        });

        if (!editMode) {
            document.addEventListener('keydown', this.handleKeyDown);
        }
    }

    componentWillUnmount() {
        turnOffPhotosUpdateNotification();
        document.removeEventListener('keydown', this.handleKeyDown);
        this.props.removePhotoSelection();
    }

    handleKeyDown(event) {
        const { photos } = this.props
        if (photos.length !== 0) {
            switch (event.key) {
            case 'ArrowRight':
                this.changeChosenPhotoIndex(1);
                break;
            case 'ArrowLeft':
                this.changeChosenPhotoIndex(-1);
                break;
            default:
                break;
            }
        }  
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            axiosInstance,
            chosenFlight,
            photos,
            getPhotos,
            selectedPhotoId,
            getPhotoFaults,
            selectPhoto,
            editMode,
        } = this.props;
        // Save global variable for socket notififcation. TODO: better idea!
        chosenFlightTmp = chosenFlight;

        // When flight changed, load new photo details
        if (!_.isEqual(prevProps.chosenFlight, chosenFlight)) {
            this.setState({ chosenPhotoIndex: 0 });
            getPhotos(axiosInstance, chosenFlight ? chosenFlight.id : 0);
        }

        // When photos changed, select current or first photo
        if (!_.isEqual(prevProps.photos, photos)) {
            if (photos[0]) {
                let selectedPhotoIndex = this.getSelectedIdx(photos, selectedPhotoId);

                selectPhoto(photos[selectedPhotoIndex].id);
                this.setState({ chosenPhotoIndex: selectedPhotoIndex });
                getPhotoFaults(axiosInstance, selectedPhotoId);
            }
        }

        // When photo selected changed, show selected photo
        if (prevProps.selectedPhotoId !== selectedPhotoId) {
            if (selectedPhotoId) {
                let selectedPhotoIndex = this.getSelectedIdx(photos, selectedPhotoId);

                this.setState({ chosenPhotoIndex: selectedPhotoIndex });
                getPhotoFaults(axiosInstance, selectedPhotoId);
            }
        }

        // When map mode is changed, remove or add keyDown event listener
        if (prevProps.editMode !== editMode) {
            if (editMode) {
                document.removeEventListener('keydown', this.handleKeyDown);
            } else {
                document.addEventListener('keydown', this.handleKeyDown);
            }
        }
    }

    getSelectedIdx(photos, selectedPhotoId) {
        let selectedPhotoIndex = photos.findIndex(photoDetail => {
            return photoDetail.id === selectedPhotoId;
        });
        return selectedPhotoIndex = selectedPhotoIndex >= 0 ? selectedPhotoIndex : 0;
    }

    render() {
        const {
            BASE_URL,
            t,
            photos,
            roles,
            chosenFlight,
            editMode,
        } = this.props;

        const {
            chosenPhotoIndex,
            brightness,
            contrast,
        } = this.state;

        const photoDetails = photos[chosenPhotoIndex];
        const imageVisible = chosenFlight && photoDetails ? true : false;

        if (imageVisible) {
            const projectId = photoDetails.projectId;
            const photoId = photoDetails.id;
            const url = `${BASE_URL}projects/${projectId}/photos/${photoId}`;
            const { faultPhotos } = photoDetails;
            return (
                <div style={{ height: '100%', width: '100%' }}>
                    <TilesGalleryWrapper
                        brightness={brightness}
                        contrast={contrast}
                        onClick={(e) => {
                            this.setState({ menuVisible: false })
                            e.stopPropagation();
                        }}
                    >
                        {photoDetails.fileStatus === 4
                            ? <TiledImageMap
                                maxZoom={photoDetails.maxZoom}
                                imageWidth={photoDetails.width}
                                imageHeight={photoDetails.height}
                                url={url}
                                photoId={photoId}
                                resizeObservable={this.props.childProps.resizeObservable}
                                faultPhotos={faultPhotos}
                                photos={photos}
                            />
                            : <StyledIconWrapper shown='true'>
                                <ReactSVG
                                    path={PhotoIcon}
                                    style={{
                                        fill: '#ffffff',
                                        width: '50px',
                                        height: '50px'
                                    }}
                                />
                                <p>{t('Photo is still being proccessed')}</p>
                            </StyledIconWrapper>}
                        <DefaultButton
                            style={{ position: 'absolute' }}
                            className='previousPhotoRoundedButton'
                            left="5px"
                            top="45%"
                            title={t('Previous photo')}
                            disabled={editMode}
                            onClick={() => {
                                this.changeChosenPhotoIndex(-1)
                            }}
                        >
                            <StyledIcon src={IconPrevious} />
                        </DefaultButton>
                        <DefaultButton
                            style={{ position: 'absolute' }}
                            className='previousPhotoRoundedButton'
                            right="5px"
                            top="45%"
                            title={t('Next photo')}
                            disabled={editMode}
                            onClick={() => {
                                this.changeChosenPhotoIndex(1)
                            }}>
                            <StyledIcon src={IconNext} />
                        </DefaultButton>
                        <DefaultButton
                            style={{ position: 'absolute' }}
                            left="5px"
                            top="5px"
                            title={t('Menu')}
                            onClick={(e) => {
                                this.setState({
                                    menuVisible: !this.state.menuVisible
                                })
                                e.stopPropagation();
                            }}>
                            <StyledIcon src={IconMenu} />
                        </DefaultButton>
                        {/* TODO: Dodawanie usterki bezpośrednio na zdjęciu
                        <DefaultButton
                            style={{ position: 'absolute' }}
                            left="5px"
                            top="130px"
                            type='warning'
                            title={t('Mark fault')}
                            onClick={(e) => {
                                this.props.startMarkingFault({});
                            }}>
                            <StyledIcon src={FaultIcon} />
                        </DefaultButton>*/}
                        <DropdownMenu
                            style={
                                {
                                    top: '35px',
                                    left: '10px',
                                    zIndex: 15
                                }
                            }
                            menuVisible={this.state.menuVisible}
                        >
                            <DropDownListRow
                                disabled={!true}
                                title={t('Center map')}
                                onClick={() => {
                                    const { centerMap, photos }: Props = this.props;
                                    const { chosenPhotoIndex } = this.state;
                                    const { longitude, latitude } = photos[chosenPhotoIndex];
                                    const center = proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857");
                                    centerMap(center);
                                }}
                            >
                                <span>{t('Center map')}</span>
                            </DropDownListRow>
                            <DropDownListRow
                                title={t('Reverse browser order')}
                                onClick={() => {
                                    this.setState({ displayOrder: !this.state.displayOrder });
                                }}
                            >
                                <span>{t('Reverse browser order')}</span>
                            </DropDownListRow>
                            <DropDownListRow
                                style={{
                                    display: roles === 'Regular' ? 'none' : 'block'
                                }}
                                title={t('Delete photo')}
                                onClick={() => {
                                    this.deletePhoto()
                                }}
                            >
                                <span>{t('Delete photo')}</span>
                            </DropDownListRow>
                            <DropDownListRow
                                title={t('Show adjustment menu')}
                                onClick={() => {
                                    this.setState({
                                        imageAdjustmentMenuVisible: true
                                    })
                                }}
                            >
                                <span>{t('Adjustment')}</span>
                            </DropDownListRow>
                        </DropdownMenu>
                        <ImageAdjustmentMenu
                            visible={this.state.imageAdjustmentMenuVisible}
                            closeMenu={this.closeAdjustmentMenu.bind(this)}
                            setBrightness={this.setBrightness.bind(this)}
                            setContrast={this.setContrast.bind(this)}
                        />
                    </TilesGalleryWrapper>
                </div>
            );
        }
        else {
            if (chosenFlight === null) {
                return (
                    <StyledIconWrapper shown={!imageVisible}>
                        <ReactSVG
                            path={PhotoIcon}
                            style={{
                                fill: '#ffffff',
                                width: '50px',
                                height: '50px'
                            }}
                        />
                        <p> {t('No mission selected please select')} </p>
                    </StyledIconWrapper>
                );
            }
            return (
                <StyledIconWrapper
                    shown={!imageVisible}
                >
                    <ReactSVG
                        path={PhotoIcon}
                        style={{
                            fill: '#ffffff',
                            width: '50px',
                            height: '50px'
                        }}
                    />
                    <p> {t('No photos for chosen mission')} </p>
                </StyledIconWrapper>);
        }
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    chosenFlight: state.flightManager.get('chosenFlight'),
    chosenProject: state.auth.get('chosenProject'),
    photos: state.photos.get('photos'),
    roles: state.auth.get('roles'),
    selectedPhotoId: state.photos.get('selectedPhotoId'),
    editMode: state.mapData.get(MAP_MODE),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    getPhotos,
    deletePhoto,
    selectPhoto,
    centerMap,
    startDrawingFaultPhoto,
    getPhotoFaults,
    removePhotoSelection,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(TilesGallery));


// WEBPACK FOOTER //
// ./src/containers/content/grid/tilesGalleryWrapper/TilesGalleryWrapper.jsx